import type { GQLLocale } from 'graphql-ts-types';
import { SubscriptionState, SubscriptionType } from 'graphql-ts-types';

import { executeQuery } from 'common/gql';
import type {
  UserSubscriptionsQuery,
  UserSubscriptionsQueryVariables,
} from 'common/gql/generated/schema';
import subscriptons from '../gql/subscriptions.gql';

const querySubscriptions = (variables: UserSubscriptionsQueryVariables) =>
  executeQuery<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>({
    variables,
    query: subscriptons,
    useApq: true,
  });

export const getIsHomeClubNewsletterSubscribed = async (locale: GQLLocale) => {
  const response = await querySubscriptions({ locale });

  const isHomeClubNewsletterSubscribed = response.user.subscriptions.some(
    subscription =>
      subscription.type.key === SubscriptionType.HomeClubNewsletter &&
      [
        SubscriptionState.Confirmed,
        SubscriptionState.Subscribed,
        SubscriptionState.Pending,
      ].includes(subscription.state)
  );

  return isHomeClubNewsletterSubscribed;
};
